<template>
    <div class="notificationRow pointer" :class="{ new: !item.readOn }" @click="navigate">
        <localized-text localizedKey="Nuovo messaggio in chat da " text="Nuovo messaggio in chat da "></localized-text>&nbsp;<b>{{item.author.name}}</b>
    </div>
</template>
<script lang="ts">
import { Watch, Prop } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import { BackendNotificationClient } from '@/services/Services';
import store from '@/store';

@Options({})
export default class backendNotificationNewChatMessage extends Vue {

    @Prop() item: OM.BackendNotificationNewChatMessage;

    navigate(){
        BackendNotificationClient.setRead(this.item.identifier);
        this.$emit('close');
        this.$router.push('/chat/' + this.item.chatIdentifier);
    }

}

</script>
